module.exports = __webpack_public_path__ + "static/green_divider_left-5c081c663348bb9fc8fe09722eed90a2.png";